// extracted by mini-css-extract-plugin
export default {"CandidateBadge":"CandidateBadge_CandidateBadge__dRdOw"};